import {
  ACTION_LOGISTIQUE_LAISSER_EN_PLACE, ACTION_LOGISTIQUE_LAISSER_EN_PLACE_VENTE,
  ACTION_LOGISTIQUE_MANUEL,
} from '@/configuration/logistique/tfs/tourneeFaceSemaineConf';
import { LIST_ICON_AND_COLOR } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

export function getIcon(face) {
  if (face.indexRegroupement === -1 && face.actionLogistique === ACTION_LOGISTIQUE_MANUEL) return 'alpha-z-box';
  if (face.indexRegroupement === -2
    && (face.actionLogistique === ACTION_LOGISTIQUE_LAISSER_EN_PLACE || face.actionLogistique === ACTION_LOGISTIQUE_LAISSER_EN_PLACE_VENTE)) return 'alpha-y-box';
  return LIST_ICON_AND_COLOR[(face.indexRegroupement - 1) % 24].icon;
}

export function getBackgroundColor(face) {
  if (face.actionLogistique === ACTION_LOGISTIQUE_MANUEL && face.indexRegroupement === -1) return 'has-background-manuel';
  if ((face.actionLogistique === ACTION_LOGISTIQUE_LAISSER_EN_PLACE
    || face.actionLogistique === ACTION_LOGISTIQUE_LAISSER_EN_PLACE_VENTE)
    && face.indexRegroupement === -2) {
    return 'has-background-laisserEnPlace';
  }
  return LIST_ICON_AND_COLOR[(face.indexRegroupement - 1) % 24].class;
}
